/* eslint-disable @typescript-eslint/no-unused-vars */
import { rebateOfferAssets } from "assets/cdn";
import {
	IconImage,
	Container,
	NotificationIcon,
	ProgressBarContainer,
	CountdownStyles,
	CountdownIconStyles,
	CountdownLabelStyles
} from "./styles";
import CountdownV2 from "components/CountdownV2";
import { useImagePath } from "hooks/useImagePath";
import { RewardContainer, RewardItem, ItemImage } from "./styles";
import { useRebateIconLogic } from "./hooks/useRebateIconLogic";
import { ProgressBar } from "../ProgressBar";

interface Props {
	from?: string;
}

export const RebateIcon: React.FC<Props> = ({ from }) => {
	const { getImage } = useImagePath("cdn");
	const iconUrl = getImage(rebateOfferAssets.icon);
	const {
		isDisabled,
		onClick,
		handleOnEnd,
		rebateOfferData,
		nowTime,
		currentProgress,
		rewardType
	} = useRebateIconLogic(from);

	if (isDisabled()) {
		return null;
	}

	return (
		<Container
			className={`animate animate__animated animate__fadeIn ${from}`}
			onClick={onClick}
			filter={0}
		>
			<IconImage className={`${from}`} src={iconUrl} />
			{rebateOfferData?.rebateTracker?.expirationDate && (
				<CountdownV2
					text=""
					startTime={nowTime}
					endTime={rebateOfferData?.rebateTracker?.expirationDate ?? ""}
					onEnd={handleOnEnd}
					style={CountdownStyles}
					iconStyle={CountdownIconStyles}
					labelStyle={CountdownLabelStyles}
				/>
			)}

			{rebateOfferData?.rebateTracker && (
				<NotificationIcon>
					{rebateOfferData?.rebateTracker?.earnedCount}
				</NotificationIcon>
			)}
			<ProgressBarContainer>
				<ProgressBar
					currentProgress={currentProgress}
					totalProgress={rebateOfferData?.rebateTracker?.targetSpend ?? 0}
					isCurrentTierActive={true}
				/>
			</ProgressBarContainer>
			<RewardContainer>
				<RewardItem>
					<ItemImage src={rewardType?.imageUrl} alt="" />
				</RewardItem>
			</RewardContainer>
		</Container>
	);
};
